<template>
    <div>
        <div class="text-center" v-show="users.length == 0">
            <h3>{{ searchMessage }}</h3>
        </div>
        <visible-user-list-item
                v-for="user in users"
                :user_id="user.user_id"
                :first_nm="user.first_nm"
                :last_nm="user.last_nm"
                :email="user.email"
                @select="selectUser"
        ></visible-user-list-item>
    </div>
</template>

<style>

</style>

<script>
    export default{
        props: {
            filter: { default: '' },
            includeAdmin: {default: false}
        },

        data: function() {
            return {
                users: []
            }
        },

        computed: {
            searchMessage: function() {
                if (this.users.length == 0 && this.filter.length <= 3) return 'Enter at least 3 characters to search.'
                else return 'No Users Found';
            }
        },

        watch: {
            filter: function() {
                this.queueUserSearch();
            }
        },
        
        methods: {
            getUsers: function(success) {
                if (this.filter.length < 3) return;
                var request = this.$http.get('/admin/user-search', { params: { filter: this.filter , all_users: this.includeAdmin ? 1 : 0  } });
                request.then(function(response) {
                    this.users = [];
                    if (response.data) {
                        for (var i=0;i<response.data.length;i++) {
                            this.users.push(response.data[i]);
                        }
                    }
                    if (typeof success === 'function') success(response);
                });
            },

            queueUserSearch: function() {
                var vm = this;
                if (this.searchTimerId) clearTimeout(this.searchTimerId);
                this.searchTimerId = setTimeout(function() {
                    vm.getUsers();
                }, 250);
            },

            selectUser: function(user_id, first_nm, last_nm, email) {
                this.$emit('select', user_id, first_nm, last_nm, email);
            }
        },

        mounted: function() {
            this.getUsers();
        }
    }
</script>



// WEBPACK FOOTER //
// visible-user-list.vue?80b9ec58